import colors from '../../../../../public/colors'


export const REGISTER_SCROLLBAR_STYLES = `
    [data-register-scroll-container] {
        -ms-overflow-style: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-color: transparent transparent;
        scrollbar-width: thin;
    }

    [data-register-scroll-container]::-webkit-scrollbar {
        height: 6px;
        width: 6px;
    }

    [data-register-scroll-container]::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 3px;
    }

    [data-register-scroll-container]::-webkit-scrollbar-thumb {
        background: transparent;
        border-radius: 3px;
        transition: background 0.3s ease;
    }

    [data-register-scroll-container].is-scrolling::-webkit-scrollbar-thumb {
        background: #8A96A3;
    }

    [data-register-scroll-container].is-scrolling::-webkit-scrollbar-thumb:hover {
        background: #6B7A8A;
    }

    [data-register-scroll-container].is-scrolling {
        scrollbar-color: #8A96A3 transparent;
    }

    [data-inner-scroll] {
        scrollbar-color: transparent transparent;
        scrollbar-width: thin;
    }

    [data-inner-scroll]::-webkit-scrollbar {
        height: 6px;
        width: 6px;
    }

    [data-inner-scroll]::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 3px;
    }

    [data-inner-scroll]::-webkit-scrollbar-thumb {
        background: transparent;
        border-radius: 3px;
        transition: background 0.3s ease;
    }

    [data-inner-scroll].is-scrolling {
        scrollbar-color: #8A96A3 transparent;
    }

    [data-inner-scroll].is-scrolling::-webkit-scrollbar-thumb {
        background: #8A96A3;
    }

    [data-inner-scroll].is-scrolling::-webkit-scrollbar-thumb:hover {
        background: #6B7A8A;
    }
`


export default theme => {
    const { mode } = theme.palette
    const palette = colors[mode] || colors.light
    const isDarkMode = mode === 'dark'
    const darkLabelColor = '#FEDF01'

    return {
        '@global': {
            '[data-register-scroll-container]': {
                '-ms-overflow-style': 'auto',
                '-webkit-overflow-scrolling': 'touch',
                scrollbarColor: 'transparent transparent',
                scrollbarWidth: 'thin'
            },
            '[data-register-scroll-container]::-webkit-scrollbar, [data-register-scroll-container] *::-webkit-scrollbar': {
                height: 6,
                width: 6
            },
            '[data-register-scroll-container]::-webkit-scrollbar-track, [data-register-scroll-container] *::-webkit-scrollbar-track': {
                background: 'transparent',
                borderRadius: 3
            },
            '[data-register-scroll-container]::-webkit-scrollbar-thumb, [data-register-scroll-container] *::-webkit-scrollbar-thumb': {
                background: 'transparent',
                borderRadius: 3,
                transition: 'background 0.3s ease'
            },
            '[data-register-scroll-container].is-scrolling': {
                scrollbarColor: '#8A96A3 transparent'
            },
            '[data-register-scroll-container].is-scrolling::-webkit-scrollbar-thumb': {
                background: '#8A96A3'
            },
            '[data-register-scroll-container].is-scrolling::-webkit-scrollbar-thumb:hover': {
                background: '#6B7A8A'
            },
            '[data-inner-scroll]': {
                scrollbarColor: 'transparent transparent',
                scrollbarWidth: 'thin'
            },
            '[data-inner-scroll]::-webkit-scrollbar': {
                height: 6,
                width: 6
            },
            '[data-inner-scroll]::-webkit-scrollbar-track': {
                background: 'transparent',
                borderRadius: 3
            },
            '[data-inner-scroll]::-webkit-scrollbar-thumb': {
                background: 'transparent',
                borderRadius: 3,
                transition: 'background 0.3s ease'
            },
            '[data-inner-scroll].is-scrolling': {
                scrollbarColor: '#8A96A3 transparent'
            },
            '[data-inner-scroll].is-scrolling::-webkit-scrollbar-thumb': {
                background: '#8A96A3'
            },
            '[data-inner-scroll].is-scrolling::-webkit-scrollbar-thumb:hover': {
                background: '#6B7A8A'
            }
        },
        appBar: {
            '@media screen and (max-width: 431px)': {
                backgroundColor: isDarkMode ? palette.secondaryBackground : '#ffffff',
                paddingLeft: '50px',
                paddingTop: '40px'
            },
            backgroundColor: isDarkMode ? palette.secondaryBackground : '#eeeeee',
            paddingLeft: '30px',
            paddingTop: '30px'
        },
        back: {
            '&.MuiButton-root': {
                backgroundColor: 'transparent',
                border: isDarkMode ? '1px solid #FFFFFF' : '1px solid #003168',
                color: isDarkMode ? '#FFFFFF' : '#003168'
            },
            '&.MuiButton-root:hover': {
                backgroundColor: 'transparent',
                border: isDarkMode ? '1px solid #FFFFFF' : '1px solid #003168',
                color: isDarkMode ? '#FFFFFF' : '#003168'
            },
            borderRadius: '2px',
            fontSize: '12px',
            fontWeight: 400,
            height: '32px',
            letterSpacing: '0.07px',
            lineHeight: '12px',
            marginRight: theme.spacing(1),
            width: '79px'
        },
        button: {
            '&.MuiButton-root': {
                border: '1px solid #006AC3',
                borderRadius: '4px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                height: '40px'
            }
        },
        buttonContainer: {
            display: 'flex',
            padding: theme.spacing(3, 0, 3, 0)
        },
        buttonRow: {
            '@media screen and (max-width: 431px)': {
                marginTop: 0
            },
            float: 'right',
            justifyContent: 'space-between',
            marginTop: theme.spacing(5),
            paddingLeft: '0px',
        },
        buttonRowSmallScreen: {
            marginTop: theme.spacing(12)
        },
        cancel: {
            borderRadius: '2px',
            color: '#677589',
            fontSize: '12px',
            fontWeight: 400,
            height: '32px',
            letterSpacing: '0.07px',
            lineHeight: '12px',
            width: '79px'
        },
        checkboxMain: {
            '& .au-checkbox-outline-checked': { fill: isDarkMode ? 'var(--primary, #FEDF01)' : '#003168' },
            '& .MuiSvgIcon-root': { backgroundColor: 'transparent', fill: isDarkMode ? 'var(--primary, #FEDF01)' : 'rgba(0, 49, 104, 0.9)', fontSize: '16px' },
            '&.Mui-focusVisible': {
                outline: 'none'
            },
            color: isDarkMode ? 'var(--primary, #FEDF01)' : '#A3A3A3',
            fill: isDarkMode ? 'var(--primary, #FEDF01)' : '#003168',
            marginRight: '5px'
        },
        formGrid: {
            marginTop: '1rem'
        },
        gridContainerCenter: {
            '@media screen and (max-width: 431px)': {
                backgroundColor: isDarkMode ? palette.secondaryBackground : '#ffffff',
            },
            backgroundColor: isDarkMode ? palette.secondaryBackground : 'transparent',
            display: 'flex',
            justifyContent: 'center',
            width: '100%'
        },
        gridContainerPadding: {
            '@media screen and (max-width: 431px)': {
                height: 'calc(100% - 100px)',
                overflowY: 'auto',
                padding: theme.spacing(3, 2, 0, 2)
            },
            padding: theme.spacing(7.5, 0, 3, 0)
        },
        gridContainerPaddingSuccess: {
            '@media screen and (max-width: 431px)': {
                padding: theme.spacing(4, 0, 4, 0)
            },
            padding: theme.spacing(4, 4, 4, 0)
        },
        helperText: {
            color: isDarkMode ? palette.secondaryText : 'rgba(0, 0, 0, 0.54)'
        },
        inputMataLabelProps: {
            '&.Mui-focused': {
                color: isDarkMode ? darkLabelColor : '#003168'
            },
            '@media screen and (max-width: 431px)': {
                '&.Mui-focused': {
                    color: isDarkMode ? darkLabelColor : '#rgba(0, 0, 0, 0.60)'
                },
                fontFamily: 'Roboto',
                fontSize: '16px',
                fontWeight: 400,
                letterSpacing: '0.1px',
                lineHeight: '20px',
            },
            color: isDarkMode ? palette.secondaryText : 'rgba(0,0,0,0.54)',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontWeight: 400,
            letterSpacing: '0.1px',
            lineHeight: '20px',
        },
        interestedIn: {
            '@media screen and (max-width: 1399px)': {
                columnGap: '6px',
                display: 'grid',
                gridTemplateColumns: 'repeat(1, 1fr)',
                marginLeft: '0px',
            },
            columnGap: '6px',
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        interestedInChild: {
            marginBottom: theme.spacing(2),
        },
        interestedInContainer: {
            display: 'flex',
            flexDirection: 'row',
            marginTop: theme.spacing(4),
        },
        interestedInMobile: {
            columnGap: '6px',
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
        },
        interestedInTitle: {
            '@media screen and (max-width: 431px)': {
                minWidth: 'fit-content'
            },
            color: 'rgba(0,0,0,0.54)',
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '0.1px',
            lineHeight: '20px'
        },
        labelMain: {
            color: '#60666D',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: 'normal'
        },
        MATALogo: {
            width: '150px'
        },
        paddingContainer: {
            paddingTop: '48px',
        },
        rcAnchorErrorMsgContainer: {
            display: 'none'
        },
        recaptcha: {
            '@media screen and (max-width: 431px)': {
                padding: 0
            },
            ...(isDarkMode ? { backgroundColor: palette.primaryBackground } : {}),
            border: isDarkMode ? `1px solid ${palette.divider}` : 'none',
            borderRadius: 6,
            boxSizing: 'border-box',
            height: 67,
            isolation: 'isolate',
            overflow: 'hidden',
            width: 259
        },
        submit: {
            backgroundColor: '#003168',
            borderRadius: '2px',
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: 400,
            height: '32px',
            letterSpacing: '0.07px',
            lineHeight: '12px',
            width: '76px'
        },
        submitFr: {
            width: '90px'
        },
        submitRequestContainer: {
            '@media screen and (max-width: 320px)': {
                minHeight: '40vh',
                padding: '0px'
            },
            borderRadius: '8px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            minHeight: '55vh',
            padding: '32px'
        },
        title: {
            color: isDarkMode ? palette.primaryText : '#003168',
            fontFamily: 'Roboto',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '24px',
            fontFeatureSettings: '\'liga\' off, \'clig\' off'
        },
        titleHeader: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
        },
        toolbar: {
            alignItems: 'center',
            display: 'flex',
            height: 'inherit',
            justifyContent: 'space-between',
            paddingRight: '64px',
        },
        toolbarMobile: {
            alignItems: 'flex-start',
            paddingRight: '16px'
        },
        verbiage: {
            color: isDarkMode ? palette.secondaryText : '#60666D',
            fontSize: '16px',
            fontWeight: '400',
            letterSpacing: '0',
            lineHeight: '24px',
            paddingTop: '16px',
            whiteSpace: 'pre-line'
        },
        verbiage3: {
            color: isDarkMode ? palette.secondaryText : 'rgba(0, 0, 0, 0.54)',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: 'normal',
            paddingBottom: '16px',
            paddingTop: '16px',
        },
        pageWrapper: {
            backgroundColor: isDarkMode ? palette.secondaryBackground : '#F8F9FB',
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            overflow: 'hidden'
        },
        scrollContainer: {
            '&::-webkit-scrollbar': {
                height: 6,
                width: 6
            },
            '&::-webkit-scrollbar-thumb': {
                background: 'transparent',
                borderRadius: 3,
                transition: 'background 0.3s ease'
            },
            '&::-webkit-scrollbar-track': {
                background: 'transparent',
                borderRadius: 3
            },
            '&.is-scrolling::-webkit-scrollbar-thumb': {
                background: '#8A96A3'
            },
            '&.is-scrolling::-webkit-scrollbar-thumb:hover': {
                background: '#6B7A8A'
            },
            '-ms-overflow-style': 'auto',
            '-webkit-overflow-scrolling': 'touch',
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            minHeight: 0,
            overflowY: 'auto',
            scrollbarColor: 'transparent transparent',
            scrollbarWidth: 'thin'
        },
        productContentContainer: {
            ...(isDarkMode ? {
                '& .MuiFormLabel-root.Mui-focused': {
                    color: darkLabelColor
                },
                '& .MuiInput-underline.Mui-focused:not(.Mui-error):after': {
                    borderBottomColor: '#FEDF01'
                }
            } : {}),
            backgroundColor: isDarkMode ? palette.primaryBackground : '#ffffff',
            border: `1px solid ${isDarkMode ? palette.divider : '#e0e0e0'}`,
            borderRadius: 8,
            boxShadow: 'none',
            margin: '0 auto',
            maxWidth: 847,
            overflow: 'hidden',
            padding: 0,
            width: '100%'
        },
        cardHeader: {
            alignItems: 'center',
            borderBottom: `1px solid ${isDarkMode ? palette.divider : '#e0e0e0'}`,
            display: 'flex',
            height: 64,
            padding: '0 24px'
        },
        cardBody: {
            maxHeight: 476,
            overflowY: 'auto',
            padding: '24px',
        },
        cardFooter: {
            alignItems: 'center',
            borderTop: `1px solid ${isDarkMode ? palette.divider : '#e0e0e0'}`,
            display: 'flex',
            height: 64,
            justifyContent: 'space-between',
            padding: '0 24px',
            position: 'relative'
        },
        selectedCountLabel: {
            color: isDarkMode ? palette.secondaryText : '#60666D',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 500,
            left: '50%',
            position: 'absolute',
            transform: 'translateX(-50%)'
        },
        productCard: {
            backgroundColor: isDarkMode ? palette.primaryBackground : '#ffffff',
            border: `1px solid ${isDarkMode ? palette.divider : '#e0e0e0'}`,
            borderRadius: 8,
            marginBottom: 16,
            padding: 24
        },
        productCardHeader: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between'
        },
        productCardTitle: {
            color: isDarkMode ? palette.primaryText : '#003168',
            fontFamily: 'Roboto',
            fontFeatureSettings: '\'liga\' off, \'clig\' off',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '24px',
            marginBottom: 8
        },
        productCardDescription: {
            color: isDarkMode ? palette.secondaryText : '#60666D',
            fontFamily: 'Roboto',
            fontFeatureSettings: '\'liga\' off, \'clig\' off',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '24px',
        },
        sectionDivider: {
            borderColor: '#E1E4E5',
            marginBottom: 16,
            marginTop: 16
        },
        instructionText: {
            color: isDarkMode ? palette.secondaryText : '#60666D',
            fontFamily: 'Roboto',
            fontFeatureSettings: '\'liga\' off, \'clig\' off',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px'
        },
        externalLink: {
            color: '#006AC3',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            textDecoration: 'underline'
        },
        rowContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            marginBottom: 16
        },
        rowPanel: {
            background: isDarkMode ? '#161F3A' : '#F9FBFC',
            border: isDarkMode ? 'none' : `1px solid #E1E4E5`,
            borderRadius: 4,
            padding: 24
        },
        rowFields: {
            alignItems: 'flex-start',
            display: 'flex',
            flexWrap: 'wrap',
            gap: 16
        },
        removeRowButton: {
            marginTop: 16
        },
        infoIcon: {
            color: 'inherit',
            cursor: 'pointer',
            fontSize: 16,
            marginLeft: 4,
            position: 'relative',
            top: '-1px'
        },
        registerTooltip: {
            background: isDarkMode ? '#2C2C2C' : 'var(--support-black-used-as-support-states-or-no-colour-provided-main, #000)',
            borderRadius: 'var(--Radius-large, 6px)',
            color: 'var(--support-white-used-as-support-states-or-no-colour-provided-main, #FFF)',
            fontFamily: 'var(--Style-Roboto, Roboto)',
            fontSize: 'var(--font-size-0625-rem, 10px)',
            fontStyle: 'normal',
            fontWeight: 'var(--Style-Medium, 500)',
            lineHeight: '14px'
        },
        registerTooltipArrow: {
            color: isDarkMode ? '#2C2C2C' : 'var(--support-black-used-as-support-states-or-no-colour-provided-main, #000)'
        },
        addDealerButton: {
            '&.MuiButton-root': {
                borderRadius: '4px',
                border: isDarkMode ? '1px solid var(--primary, #FEDF01)' : '1px solid #006AC3',
                color: isDarkMode ? 'var(--primary, #FEDF01)' : 'var(--primary, #006AC3)',
                fontFamily: 'var(--Style-Roboto, Roboto)',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 'var(--Style-SemiBold, 600)',
                height: '32px',
                letterSpacing: '0.42px',
                lineHeight: '175%',
                marginTop: 8,
                textTransform: 'none'
            }
        },
        textPrimaryButton: {
            '&.MuiButton-root': {
                color: isDarkMode ? palette.primaryText : 'var(--text-primary, #003168)',
                cursor: 'pointer',
                fontFamily: 'var(--fontFamily, Roboto)',
                fontFeatureSettings: '\'liga\' off, \'clig\' off',
                fontSize: 'var(--font-size-075-rem, 12px)',
                fontStyle: 'normal',
                fontWeight: 'var(--fontWeightRegular, 400)',
                letterSpacing: '0.46px',
                lineHeight: '16px',
                textTransform: 'uppercase'
            },
            '&.MuiButton-root:hover': {
                backgroundColor: 'transparent',
                color: isDarkMode ? palette.primaryText : 'var(--text-primary, #003168)',
                cursor: 'pointer'
            }
        },
        nextButton: {
            '&.MuiButton-root': {
                alignItems: 'center',
                background: 'var(--button-primary, #FEDF01)',
                border: 'none',
                borderRadius: 'var(--borderRadius, 2px)',
                boxShadow: 'none',
                color: '#003168',
                display: 'flex',
                flexDirection: 'column',
                fontWeight: 600,
                height: 32,
                justifyContent: 'center',
                minWidth: 80,
                padding: '8px 16px'
            },
            '&.MuiButton-root.Mui-disabled': {
                background: 'var(--button-primary, #FEDF01) !important',
                color: '#003168 !important',
                cursor: 'not-allowed',
                opacity: 0.5
            },
            '&.MuiButton-root:hover': {
                background: 'var(--button-primary, #FEDF01)',
                border: 'none',
                boxShadow: 'none'
            },
            '&.MuiButton-root:focus': {
                boxShadow: 'none'
            },
            '&.MuiButton-root:active': {
                boxShadow: 'none'
            }
        },
        stepperWrapper: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            margin: '0 auto 45px auto',
            maxWidth: 847
        },
        stepItem: {
            alignItems: 'center',
            display: 'flex',
            gap: 8
        },
        stepDivider: {
            backgroundColor: isDarkMode ? palette.divider : '#bdbdbd',
            flex: '1 1 auto',
            height: 1,
            margin: '0 12px',
            maxWidth: 120
        },
        stepperCircle: {
            alignItems: 'center',
            backgroundColor: isDarkMode ? '#60666D' : '#A6A6A6',
            borderRadius: '50%',
            color: '#fff',
            display: 'flex',
            height: 32,
            justifyContent: 'center',
            width: 32
        },
        stepperCircleActive: {
            backgroundColor: isDarkMode ? '#FEDF01' : '#005b99',
            color: isDarkMode ? 'var(--background-paper-elevation-0, #121212)' : '#fff'
        },
        stepperCircleNumber: {
            color: isDarkMode ? 'var(--background-paper-elevation-0, #121212)' : '#fff',
            fontFamily: 'var(--fontFamily, Roboto)',
            fontFeatureSettings: '\'liga\' off, \'clig\' off',
            fontSize: 'var(--font-size-075-rem, 12px)',
            fontStyle: 'normal',
            fontWeight: 'var(--fontWeightRegular, 400)',
            letterSpacing: '0.4px',
            lineHeight: '16px',
            textAlign: 'center'
        },
        stepperFirstCircleNumber: {
            fontSize: '20px',
            fontWeight: 600,
            letterSpacing: 0
        },
        stepLabel: {
            color: isDarkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.87)',
            fontFamily: 'Roboto',
            fontFeatureSettings: '\'liga\' off, \'clig\' off',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            letterSpacing: '0.1px',
            lineHeight: '20px'
        },
        stepLabelInactive: {
            color: isDarkMode ? '#ffffff' : '#000'
        },
        footerWrapper: {
            paddingTop: 32
        },
        formFooter: {
            alignItems: 'center',
            borderTop: `1px solid ${isDarkMode ? palette.divider : '#e0e0e0'}`,
            display: 'flex',
            height: 64,
            justifyContent: 'space-between',
            paddingLeft: 24,
            paddingRight: 24
        },
        formActions: {
            display: 'flex',
            gap: 8
        },
        formContent: {
            padding: 24
        },
        gridContainerFill: {
            flex: 1
        },
        fieldPaddingTop: {
            paddingTop: '48px !important'
        },
        phoneRow: {
            display: 'flex',
            gap: 12
        },
        phoneCountryCol: {
            flex: '0 0 34%'
        },
        phoneNumberCol: {
            flex: '1 1 42%'
        },
        phoneExtCol: {
            flex: '0 0 20%'
        },
        registerAutocompletePopper: {
            marginTop: 6,
            zIndex: 1400
        },
        registerAutocompletePaper: {
            backdropFilter: isDarkMode ? 'blur(8px)' : 'none',
            background: isDarkMode ? `linear-gradient(180deg, ${palette.secondaryBackground} 0%, ${palette.primaryBackground} 100%)` : '#FFFFFF',
            border: isDarkMode ? `1px solid ${palette.headerBorder}` : '1px solid #E0E0E0',
            borderRadius: 10,
            boxShadow: isDarkMode ? '0 14px 34px rgba(0, 0, 0, 0.45)' : '0 6px 18px rgba(15, 23, 42, 0.08)',
            marginTop: 6,
            overflow: 'hidden'
        },
        registerAutocompleteListbox: {
            '&::-webkit-scrollbar': {
                height: 6,
                width: 6
            },
            '&::-webkit-scrollbar-track': {
                background: 'transparent',
                borderRadius: 3
            },
            '&::-webkit-scrollbar-thumb': {
                background: 'transparent',
                borderRadius: 3,
                transition: 'background 0.2s ease'
            },
            '&:hover::-webkit-scrollbar-thumb, &:active::-webkit-scrollbar-thumb': {
                background: isDarkMode ? palette.scrollBarThumbOver : palette.scrollBarThumbOver
            },
            '&:hover, &:active': {
                scrollbarColor: `${isDarkMode ? palette.scrollBarThumbOver : palette.scrollBarThumbOver} transparent`
            },
            '-ms-overflow-style': 'auto',
            padding: '6px !important',
            scrollbarColor: 'transparent transparent',
            scrollbarWidth: 'thin'
        },
        registerAutocompleteOption: {
            '&[aria-selected="true"]': {
                backgroundColor: `${isDarkMode ? 'rgba(254, 223, 1, 0.18)' : 'rgba(0, 106, 195, 0.08)'} !important`,
                color: isDarkMode ? '#FEDF01' : '#003168',
                fontWeight: 600
            },
            '&[data-focus="true"]': {
                backgroundColor: `${isDarkMode ? palette.languageHoverBackground : 'rgba(0, 106, 195, 0.08)'} !important`,
                color: isDarkMode ? palette.primaryText : 'inherit'
            },
            borderRadius: 8,
            color: isDarkMode ? palette.primaryText : 'inherit',
            fontSize: 13,
            margin: '2px 0',
            minHeight: 36,
            transition: 'background-color 0.15s ease, color 0.15s ease'
        },
        recaptchaPaddingTop: {
            paddingTop: '32px !important'
        },
        recaptchaScaled: {
            transform: 'scale(0.85)',
            transformOrigin: '0 0'
        },
        recaptchaDarkMode: {
            ...(isDarkMode ? {
                filter: 'invert(1) contrast(2) hue-rotate(180deg)',
                mixBlendMode: 'screen',
                opacity: 0.55
            } : {})
        },
        errorText: {
            color: '#f44336'
        },
        formBlockedMessage: {
            alignItems: 'center',
            display: 'flex',
            gap: 6,
            justifyContent: 'flex-end',
            paddingBottom: 16,
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 16
        },
        formBlockedIcon: {
            color: '#D32F2F',
            fontSize: '16px !important',
            flexShrink: 0
        },
        formBlockedText: {
            color: '#D32F2F',
            fontSize: '13px !important'
        },
        labelWithInfo: {
            alignItems: 'center',
            display: 'flex'
        },
        productCardContent: {
            flex: 1
        },
        productCheckbox: {
            '& .MuiSvgIcon-root': {
                color: isDarkMode ? '#A6A6A6' : '#005b99'
            },
            '&.Mui-checked .MuiSvgIcon-root': {
                color: isDarkMode ? 'var(--primary, #FEDF01)' : '#005b99',
                ...(isDarkMode ? { fill: 'var(--primary, #FEDF01)' } : {})
            },
            marginRight: '-8px'
        },
        instructionTextTight: {
            marginBottom: 8
        },
        instructionTextLoose: {
            marginBottom: 16
        },
        mataCheckboxRow: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            marginBottom: 8,
            marginLeft: -9,
            marginTop: 8
        },
        mataCheckboxItem: {
            alignItems: 'center',
            display: 'flex',
            flex: '1 1 0',
            '@media (max-width: 670px)': {
                flex: '1 1 100%'
            },
            '& .MuiSvgIcon-root': {
                color: isDarkMode ? '#A6A6A6' : '#005b99'
            },
            '& .Mui-checked .MuiSvgIcon-root': {
                color: isDarkMode ? 'var(--primary, #FEDF01)' : '#005b99',
                ...(isDarkMode ? { fill: 'var(--primary, #FEDF01)' } : {})
            }
        },
        externalLinkIcon: {
            fontSize: 14,
            marginLeft: 4,
            verticalAlign: 'middle'
        },
        dealerInput: {
            flex: 1,
            minWidth: 120,
            '@media (max-width: 480px)': {
                flex: '1 1 100%'
            }
        },
        repCodesInput: {
            '& .MuiChip-root': {
                backgroundColor: isDarkMode ? 'rgba(255, 208, 0, 0.16)' : '#E5EFF7',
                border: isDarkMode ? '1px solid rgba(255, 208, 0, 0.24)' : '1px solid #C1DAEF',
                borderRadius: '4px',
                color: isDarkMode ? '#FFC800' : '#004EA4',
                fontFamily: 'var(--Style-Roboto, Roboto)',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: 600,
                height: '21px',
                letterSpacing: '0.36px',
                lineHeight: '175%'
            },
            '& .MuiChip-root .MuiChip-deleteIcon': {
                backgroundColor: 'transparent !important',
                color: isDarkMode ? '#FFC800 !important' : '#004EA4 !important',
                fontSize: '14px !important'
            },
            '& .MuiChip-root .MuiChip-deleteIcon:hover': {
                backgroundColor: 'transparent !important'
            },
            flex: 4,
            minWidth: 180,
            '@media (max-width: 480px)': {
                flex: '1 1 100%'
            }
        },
        submitAction: {
            '&.MuiButton-root': {
                backgroundColor: '#EEB234',
                border: 'none',
                color: '#003168',
                fontWeight: 600,
                height: 36,
                minWidth: 80
            }
        },
        stepCheckIcon: {
            fontSize: 20
        },
        reviewSubtitle: {
            color: isDarkMode ? palette.secondaryText : '#60666D',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            marginBottom: 16,
            marginTop: 4
        },
        reviewHeader: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 16
        },
        reviewSelectedCount: {
            color: isDarkMode ? palette.primaryText : '#003168',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 600,
            letterSpacing: '0.17px',
            lineHeight: '20px'
        },
        editSelectionButton: {
            '&.MuiButton-root': {
                border: isDarkMode ? '1px solid #fff' : '1px solid #003168',
                borderRadius: 2,
                color: isDarkMode ? '#fff' : '#003168',
                fontSize: '12px',
                fontWeight: 500,
                height: 28,
                letterSpacing: '0.4px',
                minWidth: 130,
                padding: '4px 10px',
                textTransform: 'uppercase'
            },
            '&.MuiButton-root:hover': {
                backgroundColor: 'transparent',
                border: isDarkMode ? '1px solid #fff' : '1px solid #003168'
            }
        },
        reviewDetailsPanel: {
            background: isDarkMode ? '#161F3A' : '#F9FBFC',
            border: isDarkMode ? 'none' : `1px solid #E1E4E5`,
            borderRadius: 4,
            display: 'flex',
            gap: 80,
            marginTop: 16,
            padding: '12px 16px'
        },
        reviewDetailCol: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        },
        reviewDetailLabel: {
            color: isDarkMode ? palette.secondaryText : '#8C9399',
            fontFamily: 'Roboto',
            fontSize: '12px',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '16px'
        },
        reviewDetailValue: {
            color: isDarkMode ? palette.primaryText : '#1A1A1A',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px'
        },
        reviewRepChipRow: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 6
        },
        reviewRepChip: {
            background: isDarkMode ? 'rgba(255, 208, 0, 0.16)' : '#E5EFF7',
            border: isDarkMode ? '1px solid rgba(255, 208, 0, 0.24)' : '1px solid #C1DAEF',
            borderRadius: 4,
            color: isDarkMode ? '#FFC800' : '#004EA4',
            display: 'inline-block',
            fontFamily: 'Roboto',
            fontSize: '12px',
            fontWeight: 600,
            letterSpacing: '0.36px',
            lineHeight: '21px',
            padding: '0 8px'
        },
        cancelDialog: {
            borderRadius: 4,
            ...(isDarkMode && { background: '#101935' })
        },
        cancelDialogTitle: {
            '&.MuiDialogTitle-root': {
                alignItems: 'center',
                borderBottom: `1px solid ${isDarkMode ? palette.divider : '#E1E4E5'}`,
                color: isDarkMode ? palette.primaryText : '#003168',
                display: 'flex',
                fontFamily: 'Roboto',
                fontSize: '20px',
                fontWeight: 600,
                justifyContent: 'space-between',
                letterSpacing: '0.15px',
                lineHeight: '32px',
                padding: '16px 24px'
            }
        },
        cancelDialogCloseButton: {
            '&.MuiIconButton-root': {
                color: isDarkMode ? palette.secondaryText : '#60666D',
                padding: 4
            }
        },
        cancelDialogContent: {
            '&.MuiDialogContent-root': {
                minHeight: 320,
                padding: '20px 24px 16px'
            }
        },
        cancelDialogBodyText: {
            color: isDarkMode ? palette.secondaryText : '#60666D',
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px'
        },
        cancelDialogIllustration: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '40px auto 8px',
            position: 'relative',
            height: 180,
            width: 220
        },
        // darker rectangle — peeks from bottom-left behind the front one
        cancelDialogIllustrationBack: {
            background: isDarkMode ? 'rgba(23, 68, 103, 0.5)' : '#E0E6EC',
            borderRadius: 3,
            height: 130,
            left: 10,
            position: 'absolute',
            top: 45,
            width: 160,
            zIndex: 0
        },
        // lighter rectangle — centered in container, sits in front
        cancelDialogIllustrationFront: {
            background: isDarkMode ? '#174467' : '#F2F4F7',
            borderRadius: 3,
            height: 130,
            left: 30,
            overflow: 'hidden',
            position: 'absolute',
            top: 25,
            width: 160,
            zIndex: 1,
            // header bar across the top of the front rectangle with margin
            '&::before': {
                content: '""',
                background: isDarkMode ? 'rgba(195, 222, 252, 0.1)' : '#E6EBF0',
                borderRadius: 0,
                display: 'block',
                height: 8,
                left: 4,
                position: 'absolute',
                right: 4,
                top: 4
            }
        },
        cancelDialogXIcon: {
            color: isDarkMode ? '#4A7BA7' : '#9BA5AC',
            height: 64,
            width: 64,
            position: 'relative',
            zIndex: 2
        },
        cancelDialogActions: {
            '&.MuiDialogActions-root': {
                borderTop: `1px solid ${isDarkMode ? palette.divider : '#E1E4E5'}`,
                justifyContent: 'flex-end',
                padding: '12px 24px'
            }
        },
        cancelDialogBackButton: {
            '&.MuiButton-root': {
                border: isDarkMode ? '1px solid #fff' : '1px solid #003168',
                borderRadius: 2,
                color: isDarkMode ? '#fff' : '#003168',
                fontSize: '12px',
                fontWeight: 500,
                height: 32,
                letterSpacing: '0.46px',
                minWidth: 80,
                padding: '8px 16px',
                textTransform: 'uppercase'
            },
            '&.MuiButton-root:hover': {
                backgroundColor: 'transparent',
                border: isDarkMode ? '1px solid #fff' : '1px solid #003168'
            }
        },
        cancelDialogConfirmButton: {
            '&.MuiButton-root': {
                background: 'var(--button-primary, #FEDF01)',
                border: 'none',
                borderRadius: 2,
                boxShadow: 'none',
                color: '#003168',
                fontSize: '12px',
                fontWeight: 600,
                height: 32,
                letterSpacing: '0.46px',
                minWidth: 140,
                padding: '8px 16px',
                textTransform: 'uppercase'
            },
            '&.MuiButton-root:hover': {
                background: 'var(--button-primary, #FEDF01)',
                boxShadow: 'none'
            }
        }
    }
}
